import vueSignature from "vue-signature";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import {TheMask} from 'vue-the-mask'

// Protest Request Create
Vue.component('search-property', require('./components/Web/ProtestRequests/Create/SearchProperty.vue').default);
Vue.component('email-verification', require('./components/Web/ProtestRequests/Create/partial/EmailVerification.vue').default);
Vue.component('phone-verification', require('./components/Web/ProtestRequests/Create/partial/PhoneVerification.vue').default);
Vue.component('step1', require('./components/Web/ProtestRequests/Create/Step1.vue').default);
Vue.component('step2', require('./components/Web/ProtestRequests/Create/Step2.vue').default);
Vue.component('step3', require('./components/Web/ProtestRequests/Create/Step3.vue').default);
Vue.component('step4', require('./components/Web/ProtestRequests/Create/Step4.vue').default);
Vue.component('step5', require('./components/Web/ProtestRequests/Create/Step5.vue').default);
Vue.component('final-outcome', require('./components/Web/ProtestRequests/FinalOutcome/FinalOutcome.vue').default);
Vue.component('feedback-form', require('./components/Web/ProtestRequests/FinalOutcome/FeedbackForm.vue').default);
Vue.component('faq-page', require('./components/Web/ProtestRequests/FinalOutcome/FaqPage.vue').default);
Vue.component('donation-thank-you', require('./components/Web/ProtestRequests/FinalOutcome/DonationThankYou.vue').default);
Vue.component('tell-us-here', require('./components/Web/ProtestRequests/FinalOutcome/TellUsHere.vue').default);
Vue.component('download-final-order', require('./components/Web/ProtestRequests/FinalOutcome/DownloadFinalOrder').default);
Vue.component('donation-page', require('./components/Web/ProtestRequests/Create/partial/Donation.vue').default);
Vue.component('additional-information', require('./components/Web/ProtestRequests/Create/AdditionalInformation.vue').default);
Vue.component('change-mailing-address',require('./components/Web/ProtestRequests/ChangeMailingAddress.vue').default)
Vue.component('admin-change-mailing-address',require('./components/Admin/ProtestRequests/ChangeMailingAddress.vue').default)
// Evidence Upload
Vue.component('protest-request-evidences-create', require('./components/Web/ProtestRequests/Evidences/Create.vue').default);
Vue.component('approve-operator-evidences', require('./components/Admin/Approve.vue').default);
Vue.component('reject-operator-evidences', require('./components/Admin/Reject.vue').default);
// Cancel Protest Request
Vue.component('cancel', require('./components/UserProperty/Cancel.vue').default);
Vue.component('sign-revoke-aoa', require('./components/UserProperty/SignRevokeAoA.vue').default);

////






// Vue.component('show-evidence-operator', require('./components/Operator/Evidences.vue').default);
Vue.component('show-evidence-admin', require('./components/Admin/Evidences.vue').default);
// Vue.component('edit-evidence-operator', require('./components/Operator/EditEvidence.vue').default);
Vue.component('edit-evidence-admin', require('./components/Admin/EditEvidence.vue').default);


Vue.component('edit-protest-request', require('./components/ProtestRequests/Edit.vue').default);
Vue.component('waiting-list', require('./components/ProtestRequests/WaitingList.vue').default);

// Vue.component('resign-aoa-update-titles', require('./components/ProtestRequests/ResignAoAUpdateTitles.vue').default);
Vue.component('resign-aoa', require('./components/ProtestRequests/ResignAOA.vue').default);

Vue.component('unsubscriber', require('./components/Unsubscriber.vue').default);
Vue.component('edit-protest-request-in-admin', require('./components/Admin/ProtestRequests/Edit.vue').default);
// Vue.component('profile-questions', require('./components/ProtestRequests/ProfileQuestions.vue').default);
//Vue.component('flash', require('./components/Flash.vue').default);
Vue.component('vue-signature',vueSignature);
Vue.component('flash', require('./components/Flash.vue').default);
Vue.component("v-select", vSelect);
Vue.component("v-the-mask", TheMask);


